<template>
    <div :loading="loading" :disabled="disabled">

        <v-toolbar class="elevation-0 grey lighten-3">

            <v-toolbar-title>List of articles</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                class="mx-5"
            ></v-text-field>

            <v-btn v-if="can('magazine-article-edit')" @click="createArticle" class="mx-2" fab small
                   color="success">
                <v-icon>mdi-plus</v-icon>
            </v-btn>

        </v-toolbar>

        <ArticleList
            class="mx-5"
            :search="search"
            @openArticle="loadArticle"
            :list="list"
        ></ArticleList>

        <ArticleDetail
            :open="openArticle"
            @articleUpdated="fetchArticles"
            @closeArticle="closeArticle"
            :article="article"
        ></ArticleDetail>

    </div>

</template>

<script>

import ArticleList from './list'
import ArticleDetail from './article'

import api from '../../_api'

export default {
    name: "articles",

    components: {
        ArticleList,
        ArticleDetail
    },

    data() {
        return ({
            tabs: null,
            article: {},
            openArticle: false,
            list: [],
            loading: true,
            disabled: false,
            search: ''
        })
    },

    watch: {
        tabs(tab) {
            alert(tab)
        }
    },

    mounted() {
        this.fetchArticles();
    },

    computed: {
        TotalArticles: function () {
            return this.list.length
        },

        PublishedArticles: function () {
            return this.list.filter(a => a.is_published == 1).length
        }
    },

    methods: {

        loadArticle: function (payload) {

            this.loading = true;
            this.disabled = true;

            api.fetchArticleData(payload).then((response) => {
                this.article = response.data
            }).then(() => {
                this.openArticle = true;
                this.loading = false;
                this.disabled = false;
            }).catch(() => {
                this.loading = false;
                this.disabled = false;
            })

        },

        createArticle: function () {
            this.loading = true;
            this.disabled = true;
            this.article = {id: 0}
            this.openArticle = true;
        },

        fetchArticles: function () {

            api.fetchArticles().then((response) => {
                this.list = response.data
            }).then(() => {
                this.loading = false;
                this.disabled = false;
            });

        },

        closeArticle: function () {
            this.openArticle = false;
            this.loading = false;
            this.disabled = false;
        }
    },

};
</script>
